import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';

function PolitiqueConfidentialite() {
    const [open, setOpen] = React.useState(false);
    const [scroll, setScroll] = React.useState<DialogProps['scroll']>('paper');

    const handleClickOpen = (scrollType: DialogProps['scroll']) => () => {
        setOpen(true);
        setScroll(scrollType);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const descriptionElementRef = React.useRef<HTMLElement>(null);
    React.useEffect(() => {
        if (open) {
            const { current: descriptionElement } = descriptionElementRef;
            if (descriptionElement !== null) {
                descriptionElement.focus();
            }
        }
    }, [open]);

    const {t} = useTranslation() as {t:(key:string)=>string}
  return (
     <div>
        <button onClick={handleClickOpen('paper')}>{t("Politique de confidentialité")}</button>
            <Dialog
                open={open}
                onClose={handleClose}
                scroll={scroll}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description">

                <DialogTitle id="scroll-dialog-title" className='text-xl font-semibold text-orange-500' >{t("Politique de confidentialité")}</DialogTitle>
                <DialogContent dividers={scroll === 'paper'}>
                                                
                    <DialogContentText
                        id="scroll-dialog-description"
                        ref={descriptionElementRef}
                        tabIndex={-1}>
                        <div className="w-full h-full">
                        <p className="text-justify text-gray-700">
                            Chez <strong>Mon monsejour</strong>, la protection de vos données personnelles est une priorité. 
                            La présente politique de confidentialité a pour objectif de vous informer de manière transparente 
                            sur la manière dont nous collectons, utilisons, partageons et protégeons vos données personnelles.
                        </p>

                        <div className="text-gray-700 mt-4">
                            <h3 className="text-lg font-semibold">Données personnelles collectées:</h3>
                            <p className="text-justify">Dans le cadre de notre activité, nous sommes amenés à collecter les données suivantes:</p>
                            <ul className="list-disc pl-5 mt-2 w-full">
                            <li className="w-full">Nom et prénom</li>
                            <li className="w-full">Adresse e-mail</li>
                            <li className="w-full">Numéro de téléphone</li>
                            <li className="w-full">Informations de passeport ou de carte d’identité (si nécessaire)</li>
                            <li className="w-full">Informations de paiement (cryptées et sécurisées)</li>
                            <li className="w-full">Données de voyage (dates, destinations, préférences)</li>
                            </ul>
                        </div>

                        <div className="text-gray-700 mt-4">
                            <h3 className="text-lg font-semibold">Finalités de la collecte:</h3>
                            <p className="text-justify">Vos données personnelles sont collectées pour les finalités suivantes:</p>
                            <ul className="list-disc pl-5 mt-2 w-full">
                            <li className="w-full">Réservation de voyages, vols, hôtels, transports et autres prestations touristiques</li>
                            <li className="w-full">Communication (confirmation de réservation, informations pratiques, newsletters si consentement donné)</li>
                            <li className="w-full">Conformité aux obligations légales (douanes, sécurité, etc.)</li>
                            <li className="w-full">Amélioration de nos services</li>
                            </ul>
                        </div>

                        <p className="text-justify text-gray-700 mt-4">
                            {t("En acceptant cette politique, vous consentez à la collecte et à l'utilisation de vos informations conformément à nos pratiques décrites.")}
                        </p>
                        </div>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button className='transform active:scale-75 transition-transform' style={{backgroundColor:"#233D4D", color:"white"}} onClick={handleClose}>{t("Retour")}</Button>
                    <Button className='transform active:scale-75 transition-transform' style={{border:"2px solid #233D4D", color:"#233D4D"}} onClick={handleClose}>{t("Accepter")}</Button>
                </DialogActions>
            </Dialog>
    </div>
  )
}

export default PolitiqueConfidentialite